export const VATCODELIST_SEARCH = 'VATCODELIST_SEARCH';
export const VATCODELIST_PAGE = 'VATCODELIST_PAGE';
